module.exports = __webpack_public_path__ + "img/mapa_beer.c6dc8750.svg";